module.exports = __webpack_public_path__ + "static/media/on.d8d3b860.svg";